import React,{Component} from "react";
import "./milestone.css";
import Translation from '../../common/translation/translation.component';
import Icons from "../../icon";
import { TYPE_FUNCTION } from "../../../constants/external-constants";
export class Milestone extends Component {
    render(){
        const {milestones,activeIndex,icon,milestonesLabel,containerClass}=this.props
        const handleMilestoneClick= (index)=>{
            if (typeof this.props.handleAction === TYPE_FUNCTION) {
                this.props.handleAction(index)
            }           
        }

        return(
            <div className={`milestone-wrapper ${containerClass} `}>
                {
                    milestonesLabel &&
                    <span className="milestone-label"><Translation translationKey={milestonesLabel} /></span>
                }                 
                <div className="milestone-container">               
                    {(milestones && this.props.milestones.length > 0) && milestones.map((milestone, index) => (
                        <div key={index} className={`icon-circle-container ${`${icon ? `icon-${icon}-wrapper` : null}`} ${ this.props.isReadAndWrite? index === activeIndex + 1 ? 'next-container': "" : ""} ${index < activeIndex ? 'previousMilestone' : ''} ${index === activeIndex || index < activeIndex ? 'activeMilestone' : ''} ${index !== milestones.length - 1 ? 'has-line' : ''}`}>
                            {
                                icon ?
                                    <Icons
                                        customClassName={'icon-' + icon}
                                        name={index === activeIndex || index < activeIndex ? "check" : icon}
                                        size="20px"
                                        containerClass={`icon-${icon}-container`}
                                        onClick={(index === activeIndex || index < activeIndex) ? ()=>{handleMilestoneClick(index)}  
                                        : this.props.isReadAndWrite? (index <= activeIndex || index === activeIndex + 1 )? ()=>{handleMilestoneClick(index)} 
                                        : undefined : 
                                        undefined} 
                                    />
                                :
                                    <div className="icon-circle">
                                        {index + 1}
                                    </div>  
                            
                            }
                            <span><Translation translationKey={milestone} /></span>  
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}